import gql from 'graphql-tag';

export const remoteItemFromProviderFragment = gql`
  fragment remoteItemFromProviderFragment on RemoteItemFromProvider {
    dokkioClass
    remoteID
    credentialID
    name
    remoteItemType
    rawData
  }
`;
export default remoteItemFromProviderFragment;
